//—— 優惠券 ——
//
//  ⚠️ **後端還沒有優惠券模型。** 這一支是版面的資料來源，
//  目前固定是空陣列 —— 所以頁面現在一定是空狀態，那是對的，不是壞掉。
//
//  做券系統時：把 COUPONS 換成 API 回來的清單，欄位照下面的形狀，
//  coupon-page 一行都不用改。放在 constant/ 而不是直接寫在頁面裡，
//  就是為了讓那次替換只動一個地方。
//
//  —— 欄位 ——
//    id        券的識別碼
//    name      券名（顯示在卡片上，例「新客首購」）
//    kind      "amount" 折抵固定金額 ／ "percent" 打折
//    value     amount 時是元、percent 時是折數（85 表示 85 折）
//    min       最低消費金額；0 表示無門檻
//    scope     適用範圍的說明文字（不是程式邏輯，純顯示）
//    expireAt  到期時間（毫秒）。null 表示無期限
//    state     "usable" ／ "used" ／ "expired"
//
//  —— 為什麼 state 是後端給的，不是前端用 expireAt 算 ——
//  「過期」的判準是後端的時鐘。前端自己比對的話，使用者把裝置時間調早
//  就會看到一張早就過期的券還是「可用」，點下去才被拒絕。
//  而且 used 本來就只有後端知道。
export const COUPONS = [];

//分頁。順序就是使用者在意的順序 —— 能用的擺第一個。
export const COUPON_TABS = [
  { key: "usable", label: "可用" },
  { key: "used", label: "已使用" },
  { key: "expired", label: "已過期" },
];

//每一個分頁空著時要說什麼。
//  三個分頁空的意義完全不同：「可用」是空的才需要給他一條出路，
//  另外兩個是空的其實是好事，不必催他去做什麼。
export const COUPON_EMPTY = {
  usable: {
    title: "目前沒有可用的優惠券",
    text: "之後的活動與回饋會把券放進這裡。",
    cta: "去看看有哪些命書",
  },
  used: { title: "還沒有用過的券", text: "用掉的券會留在這裡備查。" },
  expired: { title: "沒有過期的券", text: "" },
};
